<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">      
                <!-- <h4 class="p-2">Ingresos</h4> -->
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="5">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off" >
                                <template v-if="instituciones.length" autocomplete="off">
                                    <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                        <vs-button
                            @click="getInfoGestion()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="12">
                        <vs-table>
                            <template #thead>
                            <vs-tr>
                                <vs-th>
                                    Ciclo Escolar
                                </vs-th>
                                <vs-th>
                                    Estatus
                                </vs-th>
                            </vs-tr>
                            </template>
                            <template #tbody>
                            <vs-tr
                                :key="i"
                                v-for="(tr, i) in ciclosEscolares"
                                :data="tr"
                            >
                                <vs-td>
                                {{ tr.ciclo_escolar }} 
                                </vs-td>
                                <vs-td>
                                    <vs-select filter placeholder="Seleccionar estatus de Ciclo Escolar" v-model="typeCiclo[i]" @input="getGuardarFestion(typeCiclo[i],tr.institucion_id, tr.ciclo_escolar_id)">
                                        <vs-option label="Activo" value="activo">
                                            Activo
                                        </vs-option>
                                        <vs-option label="Inactivo" value="otro">
                                            Inactivo
                                        </vs-option>
                                    </vs-select>
                                </vs-td>
                            </vs-tr>
                            </template>
                            <template #footer>
                                <vs-pagination  v-model="page" :length="pages" />           
                            </template>
                            <template #notFound>
                                No hay información
                            </template>
                        </vs-table>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import servicios from '../../../../api/requests/servicios.js'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),page: 1,
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),page: 1,
            max: 10,
            users: [
                {
                    "id": 1,
                    "ciclo_escolar_nombre": "Ciclo Escolar 2021 - 2022",
                    "ciclo_escolar_id": "1",
                },
                {
                    "id": 2,
                    "ciclo_escolar_nombre": "Ciclo Escolar 2020 - 2021",
                    "ciclo_escolar_id": "2",
                },
            ],
            opcion: '',
            typeCiclo:[],
            page: 1, 
            pages: 0, 
        }
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        
        async getInstituciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        async getCiclo() {
            const { data: response } = await servicios.getCicloGestion(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
        },
        getTypeCiclo(){
                console.log("entro if")
            if(this.ciclosEscolares != ''){
                console.log("entro if")
                let result = []
                this.ciclosEscolares.forEach(i => {
                    if(i.nombre_status === 'inactivo'){
                        result.push('otro')
                    }else{
                        result.push(i.nombre_status)
                    }
                })
                this.typeCiclo = result
                console.log(this.typeCiclo)
            }
        },
        async getGuardarFestion(info, institucion, cicloEscolar){
            const formData = new FormData()
            if(info === 'otro'){
                formData.append('status', '0')
            }
            if(info === 'activo'){
                formData.append('status', '1')
            }
            const { data: response } = await servicios.getGuardarFestion(institucion, cicloEscolar, formData)
        },
        async getInfoGestion(){
            const params = {
                
                'page': this.page || 1,
                'institucion_id': this.institucion
            }
            const { data: response } = await servicios.getInfoGestion(params)
            const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
            this.pages = Math.ceil(total/per_page) || 0
            this.ciclosEscolares = dataTable
            this.cicloId = (new Date()).getTime()
        },
    },
    watch:{
        ciclosEscolares(){
            this.getTypeCiclo()
        },
        page(){
            this.getInfoGestion()
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
</style>